import type { DSContainerProps } from "@/src/design_system/layouts_and_containers/container/types";
import { DS_SIZE } from "@/src/design_system/shared/types/size";
import { DS_SURFACE } from "@/src/design_system/shared/types/surface";

export const DS_CONTAINER_CLASSES = {
  Root: "ds-container",
} as const;

export const DS_CONTAINER_SIZE_CLASS: Record<NonNullable<DSContainerProps["size"]>, string> = {
  [DS_SIZE.ExtraSmall]: "ds-container--xs",
  [DS_SIZE.Small]: "ds-container--sm",
  [DS_SIZE.Medium]: "ds-container--md",
  [DS_SIZE.Large]: "ds-container--lg",
  [DS_SIZE.ExtraLarge]: "ds-container--xl",
} as const;

export const DS_CONTAINER_SURFACE_CLASS: Record<NonNullable<DSContainerProps["surface"]>, string> = {
  [DS_SURFACE.Default]: "ds-container--default",
  [DS_SURFACE.Raised]: "ds-container--raised",
  [DS_SURFACE.Accent]: "ds-container--accent",
  [DS_SURFACE.Info]: "ds-container--info",
  [DS_SURFACE.Success]: "ds-container--success",
  [DS_SURFACE.Warning]: "ds-container--warning",
  [DS_SURFACE.Danger]: "ds-container--danger",
} as const;
